import React from 'react'
import { useIntl } from 'react-intl'
import { useRecoilValue } from 'recoil'
import styled from '@emotion/styled'
import {
  timelineState,
  timelineEmptyState
} from 'Pages/ScheduledSendings/recoil/state/calendar'
import { storeGet, STORE_KEY_LIST, zones } from 'mailup-react-helpers'
import moment from 'moment-timezone'

const StyledTitleContainer = styled.div`
  padding-bottom: 20px;

  position: relative;

  ${({ fullWidth }) =>
    fullWidth
      ? `
      padding-right: 0;
      `
      : `
      padding-right: 35px;
      &:before {
        position: absolute;
        content: '';
        background-color: var(--mercury);
        height: 4px;
        top: 22px;
        left: calc(100% - 35px);
        right: 6px;
      }

      &:after {
        position: absolute;
        content: '';
        background-color: var(--mercury);
        width: 4px;
        top: 22px;
        bottom: 0;
        right: 6px;
      }
  `}
`

const StyledTitle = styled.div`
  background-color: rgb(113, 207, 160);
  color: var(--pure-white);
  font-size: 16px;
  padding: 10px 15px;
  border-radius: 4px;
`

const TimelineTitle = () => {
  const intl = useIntl()
  const { TimeZoneCode } = storeGet(STORE_KEY_LIST)

  const { day } = useRecoilValue(timelineState)
  const isEmptyState = useRecoilValue(timelineEmptyState)

  const getDayOfWeek = () => {
    let d
    if (day) {
      d = moment.tz(day, 'YYYY-MM-DD HH:mm', zones[TimeZoneCode])
    } else {
      d = moment.tz(
        new Date().toISOString(),
        'YYYY-MM-DD HH:mm',
        zones[TimeZoneCode]
      )
    }
    const dow = +d.format('d')
    const dayNumber = +d.format('DD')
    switch (dow) {
      case 0:
        return (
          intl.formatMessage({ id: 'Load.MailupCommon.Sunday' }) +
          ' ' +
          dayNumber
        )
      case 1:
        return (
          intl.formatMessage({ id: 'Load.MailupCommon.Monday' }) +
          ' ' +
          dayNumber
        )
      case 2:
        return (
          intl.formatMessage({ id: 'Load.MailupCommon.Tuesday' }) +
          ' ' +
          dayNumber
        )
      case 3:
        return (
          intl.formatMessage({ id: 'Load.MailupCommon.Wednesday' }) +
          ' ' +
          dayNumber
        )
      case 4:
        return (
          intl.formatMessage({ id: 'Load.MailupCommon.Thursday' }) +
          ' ' +
          dayNumber
        )
      case 5:
        return (
          intl.formatMessage({ id: 'Load.MailupCommon.Friday' }) +
          ' ' +
          dayNumber
        )
      case 6:
        return (
          intl.formatMessage({ id: 'Load.MailupCommon.Saturday' }) +
          ' ' +
          dayNumber
        )
    }
  }

  return day ? (
    <StyledTitleContainer fullWidth={isEmptyState}>
      <StyledTitle>
        {intl.formatMessage({ id: 'Load.ScheduledMailing.Scheduling' })}{' '}
        <strong>{getDayOfWeek()}</strong>
      </StyledTitle>
    </StyledTitleContainer>
  ) : null
}

export default TimelineTitle
